/** biome-ignore-all lint/style/useNamingConvention: camel case */
import {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';
import {putAffiliateTags} from '~/common/utils/affiliate_tags';
import {escapeHtml, sanitizeString} from '~/common/utils/sanitize_html';
import {Typography} from '~library/atoms/Typography';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {pebble} from '~libSass/base/_exports.sass';

export const HostMessage = ({messageFromHost, isPremium, eventType}) => {
  const origin = useSelector((state) => state.eventDetails.origin);
  const pristineHostMessage = useSelector(
    (state) => state.eventDetails.pristineHostMessage ?? false
  );
  const readMoreRef = useRef(null);
  const [showReadMore, setShowReadMore] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!messageFromHost) {
      setShowReadMore(false);
      return undefined;
    }
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (
          entry.target.scrollHeight > entry.contentRect.height ||
          entry.contentRect.height > 98 /* Fix for iphones */
        ) {
          setShowReadMore(true);
        } else {
          setShowReadMore(showReadMore);
        }
      }
    });
    observer.observe(readMoreRef.current);
    return () => observer.disconnect();
  }, [showReadMore, messageFromHost]);

  const result = isPremium ? 'P' : 'F';

  const amazonTags = {
    tag: 'web-tracking-20',
    asc_campaign: '',
    asc_source: `${eventType}|W|${result}|noreg`,
  };

  let modifiedHostMessage = '';
  try {
    if (messageFromHost) {
      modifiedHostMessage = putAffiliateTags(sanitizeString(messageFromHost), amazonTags);
    }
  } catch (e) {
    modifiedHostMessage = escapeHtml(messageFromHost);
    evite.error('Failed to put affiliate tags', e);
  }

  return (
    <div
      className={`details__host-message${
        !messageFromHost && !pristineHostMessage ? '--hidden' : ''
      }`}
      id="hostMessage"
    >
      {showReadMore
        ? <div
            ref={readMoreRef}
            className={`hosted-by__message${expanded ? '__expanded' : ''} ${
              origin === 21 ? 'fabric' : ''
            } show-code truncated`}
            data-qa-id="host-message"
          >
            {modifiedHostMessage}
          </div>
        : <div
            ref={readMoreRef}
            className={`hosted-by__message__expanded show-code ${origin === 21 ? 'fabric' : ''}`}
            data-qa-id="host-message"
          >
            {pristineHostMessage
              ? <Typography variant="paragraph2" classNames="host-message-placeholder">
                  [This is your message to your guest]
                </Typography>
              : modifiedHostMessage}
          </div>}
      {showReadMore && (
        <button
          type="button"
          onKeyUp={null}
          tabIndex={-1}
          className="hosted-by__read-more"
          onClick={() => setExpanded(!expanded)}
          data-qa-id={expanded ? 'show-less' : 'show-more'}
        >
          Show {expanded ? 'less' : 'more'}
          <ChevronIcon ratio={0.5} color={pebble} direction={expanded ? 'up' : 'down'} />
        </button>
      )}
    </div>
  );
};
